import { __module as e } from "../../../_virtual/isEAN.js";
import { a as t } from "./util/assertString.js";
Object.defineProperty(r = e.exports, "__esModule", {
  value: !0
}), r.default = function (e) {
  (0, u.default)(e);
  var t,
    r = Number(e.slice(-1));
  return s.test(e) && r === ((t = 10 - e.slice(0, -1).split("").map(function (t, r) {
    var u;
    return Number(t) * (8 === (u = e.length) || 14 === u ? r % 2 == 0 ? 3 : 1 : r % 2 == 0 ? 1 : 3);
  }).reduce(function (e, t) {
    return e + t;
  }, 0) % 10) < 10 ? t : 0);
}, u = t && t.__esModule ? t : {
  default: t
}, s = /^(\d{8}|\d{13}|\d{14})$/, e.exports = r.default, e.exports.default = r.default;
var r,
  u,
  s,
  a = e.exports;
export { a as i };